/**
 * The entry file for webpack.
 */
import { injectJavaScript } from '@flowio/browser-helpers';
import globalFeatures from './constants/features';

const find = require('lodash/find');
const get = require('lodash/get');
const session = require('@flowio/session');
const { getFeatures, isFeatureInResultEnabled } = require('./features');

const flow = require('./flow');
const queue = require('./queue');
const events = require('./events');

// Carry over existing Flow properties we care about
flow.fraud = typeof window.Flow !== 'undefined' ? window.Flow.fraud : undefined;
flow.manualInit = typeof window.Flow !== 'undefined' ? window.Flow.manualInit : undefined;
flow.optinTarget = typeof window.Flow !== 'undefined' ? window.Flow.optinTarget : undefined;

queue.processQueue();

function getExperiment() {
  return session.getExperiment();
}

function getGeo() {
  // if one exists they should all exist
  if (session.getCountry()) {
    return {
      country: session.getCountry(),
      currency: session.getCurrency(),
      language: session.getLanguage(),
      locale: session.getLocale(),
      experience: session.getExperience(),
    };
  }

  return undefined;
}

function getOrganization() {
  const org = session.getOrganization();

  if (org) {
    return { id: org };
  }

  return undefined;
}

flow.on('ready', () => {
  getFeatures().then((featureValuesResult) => {
    const isInjectCustomJSEnabled = isFeatureInResultEnabled(
      globalFeatures.INJECT_CUSTOM_JS,
      featureValuesResult,
    );
    if (isInjectCustomJSEnabled) {
      const organization = session.getOrganization();
      injectJavaScript(`https://cdn.flow.io/web/shopifyjs/custom/${organization}.js`, { async: true });
    }
  });
});

flow.set('on', 'cart.addItem', (data) => {
  const organization = getOrganization();
  const geo = getGeo();
  const experiment = getExperiment();
  const cartItem = find(data.cart.items, item =>
    item.variant_id.toString() === data.id.toString());
  const params = {
    session: { id: session.getSessionId() },
    visitor: { id: session.getVisitorId() },
    visit: { id: session.getVisitId() },
    item_number: get(data, 'id'),
    quantity: get(data, 'quantity'),
  };

  if (cartItem) {
    params.item_name = cartItem.title || cartItem.product_title;
    params.price = {
      amount: get(cartItem, 'local.price.amount'),
      currency: get(cartItem, 'local.price.currency'),
    };
  }

  if (organization) {
    params.organization = organization;
  }

  if (geo) {
    params.geo = geo;
  }

  if (experiment) {
    params.experiment = experiment;
  }
});

flow.set('on', 'cart.removeItem', (data) => {
  const organization = getOrganization();
  const geo = getGeo();
  const experiment = getExperiment();
  const params = {
    session: { id: session.getSessionId() },
    visitor: { id: session.getVisitorId() },
    visit: { id: session.getVisitId() },
    item_number: data.id,
    quantity: data.quantity,
  };

  if (organization) {
    params.organization = organization;
  }

  if (geo) {
    params.geo = geo;
  }

  if (experiment) {
    params.experiment = experiment;
  }
});


/**
 * Trigger Loaded Event
 *
 * Useful for when flow.js is manually initialized.
 *
 * Flow.set('on', 'loaded', () => Flow.init());
 */
function triggerLoaded(attempts = 0, maxRetries = 20) {
  const initial = 1;
  const maxDelay = 1000;
  const delay = Math.min(initial * (2 ** attempts), maxDelay);

  if (window.Flow && window.Flow.init) {
    events.triggerLoadedEvent();
  } else if (attempts < maxRetries) {
    setTimeout(() => {
      triggerLoaded(attempts + 1, maxRetries);
    }, delay);
  }
}

triggerLoaded();


module.exports = flow;



// WEBPACK FOOTER //
// ./static/js/v0/entry.js